export const validRodne = (item) => {
  if (item !== null) {
    const mod = item.replace('/', '') % 11;
    const dicLength = item.replace('/', '').length;
    const rcYear = item.substring(0, 2);

    if ((mod === 0 && (rcYear > 53) && dicLength === 10) || (rcYear < 53 && dicLength === 9)) {
      return true;
    }
    return false;
  }
  return true;
};

export const containsNumber = data => !/\d/.test(data);
export const mustCheck = data => [1, '1'].includes(data);

// ***********************VyzDeti***********************
export const rcFormat = (item) => {
  const match = item.match('^[0-9]{6}/[0-9]{4}$');

  if (!match) {
    return false;
  }
  return true;
};

export const yearInterval = (item) => {
  const year = item.substring(0, 2);

  if ((year > 20) && year < 95) {
    return false;
  }
  return true;
};

export const monthInterval = (item) => {
  let month = item.replace('/', '').substring(2, 4);

  if (month > 50) {
    month -= 50;
  }

  if ((month > 0 && month <= 12)) {
    return true;
  }
  return false;
};

export const dayInterval = (item) => {
  const day = parseInt(item.substring(4, 6), 10);
  let month = parseInt(item.substring(2, 4), 10);
  const thirtyDays = [2, 4, 6, 9, 11];

  if (day < 1) {
    return false;
  }

  if (month > 50) {
    month -= 50;
  }

  if (thirtyDays.includes(month)) {
    return day <= 30;
  }
  return day <= 31;
};
